import React from 'react';
import { Row, Col } from 'antd';
import type { CheckboxProps } from 'antd/es/checkbox';

import * as S from './styles';
import { Text } from '@/components/Typography';
import { ROSA_ELEMENTS_ICONS } from './constants';
import { Element } from '../../../../../hooks/useGetElements';

interface CheckboxCardProps extends CheckboxProps {
	wrap?: boolean;
	element: Element;
}

export function CheckboxCard({ element, checked, onChange, wrap = false }: Readonly<CheckboxCardProps>) {
	const icon = ROSA_ELEMENTS_ICONS[element.name];

	function handleElementSpan(): number {
		return icon && !wrap ? 12 : 24;
	}

	return (
		<S.CustomCheckbox checked={checked} onChange={onChange} $isSelected={checked ?? false}>
			<S.CardScore $position="left" $isSelected={checked ?? false}>
				<Text>+{element.score}</Text>
			</S.CardScore>
			<Row justify="space-between" align="middle" gutter={[0, 20]}>
				{icon && (
					<Col lg={24} xxl={wrap ? 24 : 10}>
						{icon}
					</Col>
				)}
				<Col lg={24} xxl={handleElementSpan()}>
					<Text>{element.description}</Text>
				</Col>
			</Row>
		</S.CustomCheckbox>
	);
}
